<template>
  <template v-if="isEditMode !== item.id && isDeleteMode !== item.id">
    <div class="hidden gap-1 md:flex">
      <template v-if="!item.checked && canUpdateChecklist && !isTaskCompleted">
        <IconButton
          :tooltip="$t('components.tooltips.duplicate')"
          variant="secondary"
          type="gray"
          size="xs"
          @click="handleDuplicateItem"
        >
          <Icon name="copy" />
        </IconButton>
        <IconButton
          :tooltip="$t('components.tooltips.edit')"
          variant="secondary"
          type="gray"
          size="xs"
          @click="handleEditMode"
        >
          <Icon name="edit-pen" />
        </IconButton>
      </template>
      <IconButton
        v-if="!item.checked && canDeleteChecklist && !isTaskCompleted"
        :tooltip="$t('components.tooltips.delete')"
        variant="secondary"
        type="gray"
        size="xs"
        @click="handleDeleteMode"
      >
        <Icon name="delete" />
      </IconButton>
      <IconButton
        v-if="canUpdateChecklist && !isTaskCompleted"
        :tooltip="$t('components.tooltips.drag')"
        variant="secondary"
        type="gray"
        size="xs"
        class="drag-handle cursor-ns-resize"
      >
        <Icon name="menu-grid" />
      </IconButton>
    </div>
    <div class="flex md:hidden gap-1">
      <IconButton
        v-if="!item.checked && !isTaskCompleted"
        variant="tertiary"
        type="gray"
        size="xs"
        @click.stop="handleOpenActionsDrawer"
      >
        <Icon name="dots-vertical" variant="fill" />
      </IconButton>
    </div>
  </template>
  <div v-show="isEditMode === item.id" class="flex flex-row items-center gap-1">
    <Button
      :label="$t('components.buttons.cancel')"
      variant="secondary"
      type="gray"
      size="xs"
      :disabled="busy"
      @click="handleEditMode"
    />
    <Button
      :label="$t('components.buttons.save')"
      variant="primary"
      size="xs"
      :loading="busy"
      @click="handleUpdateDescription"
    />
  </div>
  <div
    v-show="isDeleteMode === item.id"
    class="flex flex-row items-center gap-1"
  >
    <Button
      :label="$t('components.buttons.cancel')"
      variant="secondary"
      type="gray"
      size="xs"
      :disabled="busy"
      @click.stop="handleDeleteMode"
    />
    <Button
      :label="$t('components.buttons.delete')"
      variant="primary"
      type="destructive"
      size="xs"
      :loading="busy"
      @click.stop="handleDeleteItem"
    />
  </div>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { Button, IconButton } from "@/SharedComponents/Buttons";

defineProps({
  item: { type: Object, required: true },
  isEditMode: { type: [String, Number], required: true },
  isDeleteMode: { type: [String, Number], required: true },
  canUpdateChecklist: { type: Boolean, required: true },
  canDeleteChecklist: { type: Boolean, required: true },
  isTaskCompleted: { type: Boolean, required: true },
  busy: { type: Boolean, required: true },
});

const emit = defineEmits([
  "edit:mode",
  "delete:mode",
  "open:actions",
  "duplicate:item",
  "update:description",
  "delete:item",
]);

function handleEditMode() {
  emit("edit:mode");
}

function handleDeleteMode() {
  emit("delete:mode");
}

function handleOpenActionsDrawer() {
  emit("open:actions");
}

function handleDuplicateItem() {
  emit("duplicate:item");
}

function handleUpdateDescription() {
  emit("update:description");
}

function handleDeleteItem() {
  emit("delete:item");
}
</script>
